import { useWizard } from "react-use-wizard";
import sellSteps from "../../sellSteps";
import {
  TKeyOfDataWizardSell,
  TStringKeysOfIFillDataWizardSell,
} from "../../..";
import { EReadinessForLowerSellPrice } from "../../../../../../../shared/wizard/steps/types";
import OffersForClientStep from "../../../../../../../shared/wizard/steps/offerForRieltorFromClientStep";

interface IDoNotKnowPriceSwapStep_5 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardSell) => void;
  data: EReadinessForLowerSellPrice | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const DoNotKnowPriceSwapStep_5 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IDoNotKnowPriceSwapStep_5) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.doNotKnowPrice.swap.step_4);
    onReset(["offersForClient"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.doNotKnowPrice.swap.step_6);
  };

  return (
    <div>
      <OffersForClientStep
        onChange={onChange}
        onPrevStep={handlePrevStep}
        onNexStep={handleNexStep}
        data={data}
        isNextStepDisabled={isNextStepDisabled}
      />
    </div>
  );
};

export default DoNotKnowPriceSwapStep_5;
